import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../Utils/Utils.js";
import "../Utils/Utils.css";

function AddUserToClientModal(props) {
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    }

    // Additional password validation for client 46
    if (props.client && props.client === 46 && password !== confirmPassword) {
      props.setAlertStatusDanger("Passwords do not match");
      return;
    }

    const url = `${
      process.env.REACT_APP_SOPHYAPP_API_URL
    }/de/react/${getAccessToken()}/settings/invite_user_to_client`;
    let params = new FormData();
    params.append("email", mail);

    // Add passwords to the form data for client 46
    if (props.client && props.client === 46) {
      params.append("password", password);
      params.append("confirm_password", confirmPassword);
    }

    axios
      .post(url, params)
      .then(function () {
        props.setAlertStatusSuccess("success");
      })
      .catch(function (error) {
        console.error(error);
        const message = error.response?.data?.message || "An error occurred!";
        props.setAlertStatusDanger(message);
      });

    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("client.adduserheader")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>{t("profile.email")}</Form.Label>
            <Form.Control
              type="email"
              placeholder="user@sophyapp.com"
              value={mail}
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              required
              autoFocus
              onChange={(e) => setMail(e.target.value)}
            />
          </Form.Group>
          {props.client && props.client === 46 && (
            <>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>{t("admin.common.password")}</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
                <Form.Label>{t("admin.common.confirmPassword")}</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("mails.send")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default AddUserToClientModal;
